/**
 * TRADE 定制：ChatWILL 帮助按钮 · 移动端滚动时自动收起（向右侧贴边）
 *
 * 行为：
 *   - 页面一旦发生滚动（无论向上还是向下），按钮立即向右侧收起；
 *   - 滚动完全停止 IDLE_MS 毫秒后，按钮才从右侧滑回重新出现。
 *
 * ChatWILL 的按钮是应用异步注入 DOM 的，可能比本脚本晚出现，
 * 因此这里轮询等待按钮挂载后再绑定 scroll 事件（最多等 15s）。
 */
(() => {
  const HIDE_CLASS = 'chatwill-scroll-hidden';
  const BTN_SELECTOR = '#willlink-app .willlink-btn-container';
  const IDLE_MS = 500; // 停止滚动多久后让按钮滑回（毫秒）

  let idleTimer = null;
  let binded = false;

  function getBtn() {
    return document.querySelector(BTN_SELECTOR);
  }

  function onScroll() {
    const btn = getBtn();
    if (!btn) return;

    // 只要在滚动就立即收起
    btn.classList.add(HIDE_CLASS);

    // 停住滚动一段时间后重新滑回
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      if (btn) btn.classList.remove(HIDE_CLASS);
    }, IDLE_MS);
  }

  function tryBind() {
    if (binded) return true;
    if (!getBtn()) return false;
    window.addEventListener('scroll', onScroll, { passive: true });
    binded = true;
    return true;
  }

  // 已经能拿到按钮就直接绑；否则轮询等待 ChatWILL 注入
  if (tryBind()) return;

  let attempts = 0;
  const timer = setInterval(() => {
    if (tryBind()) {
      clearInterval(timer);
    } else if (++attempts >= 150) {
      clearInterval(timer); // 等满 15s 仍无组件则放弃
    }
  }, 100);
})();
